
<template>
    <div>
        <div class="con-form">
            
            <vs-row>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-select class="pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="docente" class="labelInput">
                            CURP <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-input class="pt-0" v-model="curp" placeholder="CURP">
                            <template #message-danger v-if="errorFields.includes('curp')">
                                {{errorCURP ? errorCURP : 'Requerido'}}
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="materno" class="labelInput">
                            Apellido paterno <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-input class="pt-0" v-model="apellido_paterno" placeholder="Apellido paterno">
                            <template #message-danger v-if="errorFields.includes('apellido_paterno')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="paterno" class="labelInput">
                            Apellido materno <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-input class="pt-0" v-model="apellido_materno" placeholder="Apellido materno">
                            <template #message-danger v-if="errorFields.includes('apellido_materno')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="nombre" class="labelInput">
                            Nombre <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-input class="pt-0" v-model="nombre" placeholder="Nombre">
                            <template #message-danger v-if="errorFields.includes('nombre')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="sexo" class="labelInput">
                            Sexo
                        </label>
                        <vs-select class="pt-0" id="sexo" placeholder="Seleccionar Institución" v-model="sexo">
                            <vs-option label="Masculino" value="masculino">
                                Masculino
                            </vs-option>
                            <vs-option label="Femenino" value="femenino">
                                Femenino
                            </vs-option>
                            <vs-option label="Sin especificar" value="porDefinie">
                                Sin especificar
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="fecha_nacimiento" class="labelInput">
                            Fecha de nacimiento <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-input
                            type="date"
                            class="pt-0"
                            v-model="fecha_nacimiento"
                        >
                            <template #message-danger v-if="errorFields.includes('fecha_nacimiento')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="correo_electronico" class="labelInput">
                            Correo electrónico <i class="fas fa-shield-alt oblig"></i>
                        </label>
                        <vs-input type="email" class="pt-0" v-model="correo" placeholder="Correo electrónico">
                            <template #message-danger v-if="errorFields.includes('correo')">
                                {{errorCorreo ? errorCorreo : 'Requerido'}}
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="celular" class="labelInput">
                            Celular
                        </label>
                        <vs-input type="number" class="pt-0" v-model="celular" placeholder="Celular">
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="telefono" class="labelInput">
                            Teléfono
                        </label>
                        <vs-input type="number" class="pt-0" v-model="telefono" placeholder="Teléfono">
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="extension" class="labelInput">
                            Extensión
                        </label>
                        <vs-input class="pt-0" v-model="extension" placeholder="Extensión">
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="clave" class="labelInput">
                            Clave de docente
                        </label>
                        <vs-input class="pt-0" v-model="clave" placeholder="Clave de docente">
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="clave" class="labelInput">
                            RFC
                        </label>
                        <vs-input class="pt-0" v-model="rfc" placeholder="RFC">
                            <template #message-danger v-if="errorRFC">
                                {{errorRFC}}
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
            </vs-row>
            <small><i class="fas fa-shield-alt oblig"></i>: Campos obligatorios</small>
        </div>

          <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="clearData()"
                >
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                <vs-button
                    success
                    @click="getCrearDocente()"
                    class="ml-auto"
                >
                    Aceptar
                </vs-button>
                </vs-col>
            </vs-row>
          </div>
      </div>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
export default {
    props:[
        'ejecutar',
        'instituciones',
        'filtros',
        'csrf_token',
        'aumentarInd'
    ],
    data:() => ({
        active: false,
        institucion: '',
        institucionD: '',
        institucionId: (new Date()).getTime(),
        docente: '',
        docentes: [],
        docenteId: (new Date()).getTime(),
        errorFields: [],
        curp:'',
        apellido_paterno: '',
        apellido_materno: '',
        nombre: '',
        sexo: '',
        fecha_nacimiento: '',
        correo: '',
        celular: '',
        telefono: '',
        extension: '',
        clave: '',
        rfc: '',
        enviar: false,
        errorCURP: '',
        errorCorreo: '',
        errorRFC: ''
    }),
    methods:{
        getFiltros(){
            this.institucion = this.filtros.institucion
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        console.log(val)
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.curp) {
                this.errorFields.push('curp')
            }
            if (!this.apellido_paterno) {
                this.errorFields.push('apellido_paterno')
            }
            if (!this.apellido_materno) {
                this.errorFields.push('apellido_materno')
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.sexo) {
                this.errorFields.push('sexo')
            }
            if (!this.fecha_nacimiento) {
                this.errorFields.push('fecha_nacimiento')
            }
            if (!this.correo) {
                this.errorFields.push('correo')
            }
            console.log(this.errorFields.length)
            if (!this.errorFields.length){
                return true
            } else {
                return false
            }
        },
        async getCrearDocente(){
            if(this.sanityForm() == true){
                const loading = this.$vs.loading()
                try {
                    const formData = new FormData()
                    formData.append('institucion_id', this.institucion)
                    formData.append('curp', this.curp)
                    formData.append('apellido_paterno', this.apellido_paterno )
                    formData.append('apellido_materno', this.apellido_materno)
                    formData.append('nombres', this.nombre)
                    formData.append('sexo', this.sexo)
                    formData.append('fecha_nacimiento', this.fecha_nacimiento)
                    formData.append('correo', this.correo)
                    formData.append('celular', this.celular)
                    formData.append('telefono', this.telefono)
                    formData.append('extension', this.extension)
                    formData.append('clave_docente', this.clave)
                    formData.append('rfc', this.rfc)
                    formData.append('_token', this.csrf_token)
                    const response = await academico.getCrearDocente(formData)
                    this.$emit('cerrarModal')
                    this.clearData()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'Se ha creado con éxito el registro'
                    })
                    
                    this.errorCURP = ''
                    this.errorCorreo = ''
                    loading.close()
                }
                catch(error){
                    const responseError = error.response
                    if (responseError.data.errors.curp && responseError.data.errors.curp[0]) {
                        this.errorFields.push('curp');
                        this.errorCURP = responseError.data.errors.curp[0];
                    } else {
                        // Filtra la lista errorFields para excluir 'curp' sin importar la posición
                        this.errorFields = this.errorFields.filter(item => item !== 'curp');
                    }

                    if (responseError.data.errors.correo && responseError.data.errors.correo[0]) {
                        this.errorFields.push('correo');
                        this.errorCorreo = responseError.data.errors.correo[0];
                    } else {
                        // Filtra la lista errorFields para excluir 'correo' sin importar la posición
                        this.errorFields = this.errorFields.filter(item => item !== 'correo');
                    }

                    if (responseError.data.errors.rfc && responseError.data.errors.rfc[0]) {
                        this.errorRFC = responseError.data.errors.rfc[0];
                    } else {
                        // Filtra la lista errorFields para excluir 'correo' sin importar la posición
                        this.errorRFC = ''
                    }
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un problema',
                        text: responseError.data.errors ? 'Favor de corregir los datos señalados' : 'Favor de comunicarse con el administrador'
                    })

                }
            }
        },
        clearData(){
            this.institucion = ''
            this.curp = ''
            this.apellido_paterno  = ''
            this.apellido_materno = ''
            this.nombre = ''
            this.sexo = ''
            this.fecha_nacimiento = ''
            this.correo = ''
            this.celular = ''
            this.telefono = ''
            this.extension = ''
            this.clave = ''
            this.rfc = ''
            this.$emit('cerrarModal')
        },
        async getDocentesVincular(){
            try {
                const {data: response} = await academico.getDocentesVincular(this.institucion)
                this.docentes = response
                this.docenteId = (new Date()).getTime()
            }
            catch{

            }
        },
    },
    watch:{
        value (val) {
            this.active = val
        },      
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        filtros(){
            console.log("filtros")
            this.getFiltros()
        },
        institucion(){
            this.getDocentesVincular()
        },
        aumentarInd(){
            this.clearData()
        }
    }
}
</script>

<style scoped>
.oblig{
    font-size: 0.7rem;
    margin-left: 3px;
}
</style>
